<template>
  <div class="url-rewriter">
    <slot></slot>
  </div>
</template>

<script>

import queryString from "query-string"
export default {
  name: 'URLRewriter',
  created()
  {
    this.tryRewriteURL()
  },
  computed : {
  },
  data()
  {
    return {

    }
  },
  methods : {
    tryRewriteURL()
    {
      var queryParams = queryString.parse(location.search);

      if(queryParams.code != null && queryParams.session_state != null && queryParams.state != null)
      {//check to see if the url is a code-response

        var config = JSON.parse(localStorage.getItem(queryParams.state));

        var strQueryParams = [];
        for(var key in queryParams)
        {//convert the json object into kvp array
          var val = queryParams[key];
          strQueryParams.push({key,val});
        }
        var queryPart = strQueryParams.map((v,k) => {
          var part = `${v.key}=${v.val}`;
          return part;
        }).join("&");
        var forwardUrl = `${config.path}?${queryPart}`

        document.location.href=forwardUrl;

        return;
      }

      var splits = document.location.href.split("#");
      var urlBeginning = splits[0];
      var hash = splits.length > 1 ? splits[1] : null;
      var mainUrl = splits[0].split("/").slice(0,3).join("/") + "/";
      var currentlyAtRoot = (mainUrl == urlBeginning);
      var path =  !currentlyAtRoot ? "/" + urlBeginning.replace(mainUrl, "") : "/";
      if(!currentlyAtRoot)
      {
        var newTarget = `${mainUrl}#${path}`;
        document.location.href = newTarget;
      }

      return;
    }
  }
}
</script>

<style scoped lang="scss">
</style>
